export const normalizeUserSession = (data, previous = {}) => {
  const user = data?.user ?? data ?? {};
  const rawType = user.tipoUsuario ?? previous.tipoUsuario ?? '';
  const normalizedType = String(rawType).trim().toLowerCase();
  const type = normalizedType === 'produtor' ? 'pecuarista' : normalizedType === 'outros' ? 'outro' : ['tecnico', 'pecuarista', 'estudante', 'pesquisador', 'empresario', 'outro'].includes(normalizedType) ? normalizedType : rawType;
  return {
    ...previous,
    ...user,
    userId: user.id ?? user._id ?? user.userId ?? previous.userId,
    nome: user.name ?? user.nome ?? previous.nome ?? '',
    telefone: user.phone ?? user.telefone ?? previous.telefone ?? '',
    email: user.email ?? previous.email ?? '',
    tamanho_rebanho: user.tamanho_rebanho ?? previous.tamanho_rebanho ?? 0,
    area_gerida: user.area_gerida !== undefined ? user.area_gerida : previous.area_gerida ?? null,
    tipoUsuario: type,
    unidade: user.configuracoes?.unidade ?? user.unidade ?? previous.unidade ?? 'kg',
  };
};
